import React, { useState } from "react";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Row,
    Col,
    Input,
    FormText,
} from "reactstrap";
import Select from 'react-select';
import { ButtonStyles } from "../../constants/ButtonStyles";
import "./modelcss.css";

export default function AddExpenseScreen({
    onBack,
    onChangeModelForm,
    onSubmitodelForm,
    expense,
    paymentTypes,
    category,
    payee,
    error,
    onAddCategory,
    onAddPayee,
    showAddCategory,
    showAddPayee,
    categoryValues,
    payeeValues,
    onChangeCategoryForm,
    onChangePayeeForm,
    onSaveCategory,
    onSavePayee,
    onCancelCategory,
    onCancelPayee,
    categoryError,
    payeeError
}) {
    return (
        <div>
            <Card>
                <CardHeader className="carheaderSmall">
                    <strong>Add Expense</strong>
                    <Button
                        onClick={onBack}
                        style={{ ...ButtonStyles.secondary, float: "right" }}
                    >
                        <i className="fa fa-arrow-left" style={{ marginRight: "8px" }}></i>
                        Back
                    </Button>
                </CardHeader>
                <CardBody>
                    <Row xs="4" style={{ marginBottom: "10px" }}>
                        <Col>Date</Col>
                        <Col>
                            <Input
                                type="date"
                                name="date"
                                id="date"
                                onChange={onChangeModelForm}
                                value={expense.date}
                            />
                        </Col>
                        <Col></Col>
                        <Col></Col>
                    </Row>

                    {/* Category Row with Add Button */}
                    <Row xs="4" style={{ marginBottom: "10px" }}>
                        <Col>Category</Col>
                        <Col>
                            <Select
                                name="category"
                                id="category"
                                value={category.filter(opt => opt.id == expense.category).map(opt => ({ value: opt.id, label: opt.category }))[0] || null}
                                onChange={(selectedOption) => onChangeModelForm({ target: { name: "category", value: selectedOption ? selectedOption.value : "0" } })}
                                options={category.map(opt => ({ value: opt.id, label: opt.category }))}
                                placeholder="Select Category"
                                isClearable
                                isSearchable
                            />
                        </Col>
                        <Col>
                            <Button style={ButtonStyles.successSm} onClick={onAddCategory}>
                                <i className="fa fa-plus" style={{ marginRight: "5px" }}></i>
                                Add Category
                            </Button>
                        </Col>
                        <Col></Col>
                    </Row>

                    {/* Inline Add Category Form */}
                    {showAddCategory && (
                        <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
                            <CardBody>
                                <Row xs="4">
                                    <Col>Category Name</Col>
                                    <Col>
                                        <Input
                                            type="text"
                                            name="name"
                                            id="categoryName"
                                            onChange={onChangeCategoryForm}
                                            value={categoryValues.name || ""}
                                        />
                                    </Col>
                                    <Col>
                                        <Button style={{ ...ButtonStyles.primarySm, marginRight: "5px" }} onClick={onSaveCategory}>
                                            <i className="fa fa-check" style={{ marginRight: "5px" }}></i>
                                            Save
                                        </Button>
                                        <Button style={ButtonStyles.dangerSm} onClick={onCancelCategory}>
                                            <i className="fa fa-times" style={{ marginRight: "5px" }}></i>
                                            Cancel
                                        </Button>
                                    </Col>
                                    <Col>
                                        {categoryError && (
                                            <FormText color="red" style={{ fontWeight: "bold" }}>
                                                {categoryError}
                                            </FormText>
                                        )}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    )}

                    {/* Payee Row with Add Button */}
                    <Row xs="4" style={{ marginBottom: "10px" }}>
                        <Col>Payee Name</Col>
                        <Col>
                            <Select
                                name="payeeName"
                                id="payeeName"
                                value={payee.filter(opt => opt.id == expense.payeeName).map(opt => ({ value: opt.id, label: opt.payeeName }))[0] || null}
                                onChange={(selectedOption) => onChangeModelForm({ target: { name: "payeeName", value: selectedOption ? selectedOption.value : "0" } })}
                                options={payee.map(opt => ({ value: opt.id, label: opt.payeeName }))}
                                placeholder="Select Payee"
                                isClearable
                                isSearchable
                            />
                        </Col>
                        <Col>
                            <Button style={ButtonStyles.successSm} onClick={onAddPayee}>
                                <i className="fa fa-plus" style={{ marginRight: "5px" }}></i>
                                Add Payee
                            </Button>
                        </Col>
                        <Col></Col>
                    </Row>

                    {/* Inline Add Payee Form */}
                    {showAddPayee && (
                        <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
                            <CardBody>
                                <Row xs="4">
                                    <Col>Payee Name</Col>
                                    <Col>
                                        <Input
                                            type="text"
                                            name="name"
                                            id="payeeNameInput"
                                            onChange={onChangePayeeForm}
                                            value={payeeValues.name || ""}
                                        />
                                    </Col>
                                    <Col>
                                        <Button style={{ ...ButtonStyles.primarySm, marginRight: "5px" }} onClick={onSavePayee}>
                                            <i className="fa fa-check" style={{ marginRight: "5px" }}></i>
                                            Save
                                        </Button>
                                        <Button style={ButtonStyles.dangerSm} onClick={onCancelPayee}>
                                            <i className="fa fa-times" style={{ marginRight: "5px" }}></i>
                                            Cancel
                                        </Button>
                                    </Col>
                                    <Col>
                                        {payeeError && (
                                            <FormText color="red" style={{ fontWeight: "bold" }}>
                                                {payeeError}
                                            </FormText>
                                        )}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    )}

                    <Row xs="4" style={{ marginBottom: "10px" }}>
                        <Col>Amount</Col>
                        <Col>
                            <Input
                                type="text"
                                name="amount"
                                id="amount"
                                onChange={onChangeModelForm}
                                value={expense.amount || ""}
                            />
                        </Col>
                        <Col>Payment Type</Col>
                        <Col>
                            <Select
                                name="paymentType"
                                id="paymentType"
                                value={paymentTypes.filter(opt => opt.configKey == expense.paymentType).map(opt => ({ value: opt.configKey, label: opt.configValue }))[0] || null}
                                onChange={(selectedOption) => onChangeModelForm({ target: { name: "paymentType", value: selectedOption ? selectedOption.value : "0" } })}
                                options={paymentTypes.map(opt => ({ value: opt.configKey, label: opt.configValue }))}
                                placeholder="Select Payment Type"
                                isClearable
                                isSearchable
                            />
                        </Col>
                    </Row>

                    <Row xs="4" style={{ marginBottom: "10px" }}>
                        <Col>Description</Col>
                        <Col>
                            <Input
                                type="textarea"
                                name="desc"
                                id="desc"
                                onChange={onChangeModelForm}
                                value={expense.desc || ""}
                            />
                        </Col>
                        <Col>Reference No.</Col>
                        <Col>
                            <Input
                                type="text"
                                name="refNum"
                                id="refNum"
                                onChange={onChangeModelForm}
                                value={expense.refNum || ""}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col style={{ textAlign: "center" }}>
                            {error && (
                                <FormText color="red" style={{ fontWeight: "bold" }}>
                                    {error}
                                </FormText>
                            )}
                        </Col>
                    </Row>

                    <Row style={{ marginTop: "20px" }}>
                        <Col style={{ textAlign: "center" }}>
                            <Button
                                onClick={onSubmitodelForm}
                                style={{ ...ButtonStyles.primary, marginRight: "15px" }}
                            >
                                <i className="fa fa-save" style={{ marginRight: "8px" }}></i>
                                Save Expense
                            </Button>
                            <Button
                                onClick={onBack}
                                style={ButtonStyles.danger}
                            >
                                <i className="fa fa-times" style={{ marginRight: "8px" }}></i>
                                Cancel
                            </Button>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/AddExpenseScreen.js